export const supportUserLoginRoutesNames = {
  SUPPORT_USER_LOGIN: 'support-login',
};
